import * as Styled from './Form.styles';

type FormProps = {
  children: React.ReactNode;
  onSubmit: () => void;
};

const Form = ({ children, onSubmit }: FormProps) => {
  return <Styled.Form onSubmit={onSubmit}>{children}</Styled.Form>;
};

export default Form;
